import axiosInstance from './AxiosWrapper'
import { ENDPOINT_DAY_FOR_MG, ENDPOINT_DAY_TOGGLE_REAL_ENABLED } from './Endpoints'

export const getDayForMGService = async (date) => {
  return await axiosInstance.get(ENDPOINT_DAY_FOR_MG, { params: { date } })
}
export const toggleRealEnabledService = async (dayId) => {
  return await axiosInstance.post(ENDPOINT_DAY_TOGGLE_REAL_ENABLED, { dayId: dayId })
}
